import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { AttachmentDto } from '../models/data.model';

@Injectable({
  providedIn: 'root',
})
export class ModalService {
  private _isOpen = new BehaviorSubject<boolean>(false);
  isOpen = this._isOpen.asObservable();

  idDocumento: any 

  private dataSubject = new BehaviorSubject<AttachmentDto[]>([]);
  data = this.dataSubject.asObservable();

  open(attachList: AttachmentDto[] = [], idDoc: any) {
    this.idDocumento = idDoc
    this.dataSubject.next(attachList)
    this._isOpen.next(true);
  }

  close() {
    this._isOpen.next(false);
  }
}
